import React from 'react';

import { getHumanizedMeetingTypeFromURL, getMeetingTypeFromURL } from 'Shared/components/MeetingConference/utils';
import { WpModal, WpModalBody, WpModalHeader } from 'Wpds/components/modal';
import WpButton from 'Wpds/components/button/WpButton';

type Props = {
  meetingUrl: string;
  onCloseModal(): void;
};

function JoinMeetingConferenceModal({ meetingUrl, onCloseModal }: Props) {
  const startMeeting = () => {
    (window as any).analytics.track('Clicked Join Meeting Conference', {
      conference: getMeetingTypeFromURL(meetingUrl),
    });
    window.open(meetingUrl, '_blank', 'noopener,noreferrer');
    onCloseModal();
  };

  const modalHeader = `Join ${getHumanizedMeetingTypeFromURL(meetingUrl)}`;

  return (
    <WpModal size="sm" isOpen onToggle={onCloseModal}>
      <WpModalHeader>{modalHeader}</WpModalHeader>
      <WpModalBody>
        <div className="text-muted mb-4">
          {`Clicking the button below will open a new window for the ${getHumanizedMeetingTypeFromURL(
            meetingUrl
          )} for the calendar event connected to this workspace.`}
        </div>
        <WpButton onClick={startMeeting} size="lg" block>
          {modalHeader}
        </WpButton>
      </WpModalBody>
    </WpModal>
  );
}

export default JoinMeetingConferenceModal;
